import { Box, Checkbox, Flex, Image, useDisclosure } from "@chakra-ui/core"
import * as R from "ramda"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { StringParam, useQueryParam } from "use-query-params"
import { Accessory } from "views/BicycleProductPage"
import useShopifyVariantPricing from "../../hooks/useShopifyVariantPricing"
import { BaseDispatch, BaseRootState } from "../../redux/store"
import { ShopifyVariantPricing } from "../../shopify/graphql/queries"
import { bp } from "../../utils/MediaQueries"
import { sortMethods } from "../../utils/sort"
import Body from "../typography/Body"
import { navigate } from "gatsby"
import { decodeShopifyId } from "../../utils"

function UpsellAccessories({
  upsellProducts,
  onAccessoryChange,
  selectedAccessories,
}) {
  const [addedToCart, setAddedToCart] = React.useState(false)
  const addedToCartModal = useDisclosure()
  // Redux
  const dispatch = useDispatch<BaseDispatch>()
  const { isCartLoading } = useSelector((state: BaseRootState) => ({
    isCartLoading: state.checkout.isLoading,
  }))

  // Sort
  const [sortParam, setSort] = useQueryParam("sort", StringParam)
  const sort = sortParam ? sortParam : "BY_RELEVANCE"

  // Pricing
  const { pricingMap } = useShopifyVariantPricing(
    R.uniq(R.flatten(upsellProducts?.map((item) => item?.shopifyId)))
  )

  return (
    <Box borderY="1px" borderColor="gray.200" mt="3rem" py="1rem">
      <Body lineHeight="1.125rem" mb="1.5rem" fontWeight={500}>
        Recommended Accessories
      </Body>
      <Flex
        w="100%"
        flexDirection="column"
        className="upsellProductList"
        style={{ gap: "10px" }}
      >
        {upsellProducts
          .map((item) => ({
            ...item,
            pricing:
              (pricingMap[item?.shopifyId ?? ""] as ShopifyVariantPricing) ||
              null,
          }))
          .sort(sortMethods[sort])
          .filter((item: Accessory) => item?.pricing?.availableForSale)
          .map((item, key) => {
            return (
              <Flex
                key={key}
                w="100%"
                flexDirection="row"
                className="upsellProduct"
              >
                <Flex
                  className="UpsellProductInfo"
                  w="80%"
                  flexDirection="row"
                  alignItems="center"
                  py="3px"
                >
                  <Checkbox
                    size="lg"
                    color="primary"
                    mx="10px"
                    onChange={(e) => {
                      onAccessoryChange(item)
                    }}
                    isChecked={selectedAccessories.find(
                      (acc: Accessory) =>
                        acc?.contentful_id === item?.contentful_id
                    )}
                  />
                  <Image
                    width={bp("60px", "80px")}
                    maxHeight={bp("60px", "80px")}
                    bg="#fff"
                    border="1px solid"
                    borderColor="gray.200"
                    p="3px"
                    src={item?.productListingImage?.fluid?.src}
                    style={{cursor: "pointer"}}
                    onClick={() => navigate(`/products/${item.accessory_model[0].internalTitle}?variant=${decodeShopifyId(item.shopifyId)}`)}
                  />
                  <Flex
                    flexDirection="column"
                    alignContent={"center"}
                    alignItems="center"
                    style={{cursor: "pointer"}}
                    justifyContent={"center"}
                    onClick={() => navigate(`/products/${item.accessory_model[0].internalTitle}?variant=${decodeShopifyId(item.shopifyId)}`)}
                  >
                    <Body
                      w="100%"
                      // color="#777"
                      fontWeight={500}
                      px="10px"
                      style={{ textTransform: "capitalize" }}
                      fontSize={bp("14px", "16px")}
                    >
                      {item && item?.accessory_model?.length
                        ? item?.accessory_model[0]?.title
                        : item?.title}
                    </Body>
                    <Body
                      w="100%"
                      // color="#999"
                      fontWeight={400}
                      px="10px"
                      style={{ textTransform: "capitalize", fontSize: "14px" }}
                    >
                      {item?.title ? "(" + item?.title + ")" : ""}
                    </Body>
                  </Flex>
                </Flex>
                <Flex
                  className="UpsellProductPrice"
                  w="20%"
                  flexDirection="column"
                  textAlign="center"
                  alignContent={"center"}
                  alignItems="center"
                  justifyContent={"center"}
                  color="primary"
                  fontWeight="bold"
                  lineHeight="1.125rem"
                  m={0}
                  p={0}
                >
                  {/* Strick Price */}
                  {item?.pricing?.compareAtPriceV2?.amount && (
                    //@ts-ignore
                    <del
                      style={{
                        // color: "#999",
                        fontWeight: "normal",
                        fontSize: "14px",
                      }}
                    >
                      ${item?.pricing?.compareAtPriceV2?.amount}
                    </del>
                  )}
                  {/* Actual Price */}
                  <span>
                    $
                    {item?.pricing?.priceV2?.amount
                      ? item?.pricing?.priceV2?.amount
                      : "FREE"}
                  </span>
                </Flex>
              </Flex>
            )
          })}
      </Flex>
    </Box>
  )
}

export default UpsellAccessories
